import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col, Glyphicon, FormGroup, FormControl, HelpBlock } from 'react-bootstrap';
import * as moment from 'moment';
import DatePicker from 'react-bootstrap-datetimepicker';
import 'react-bootstrap-datetimepicker/css/bootstrap-datetimepicker.min.css';
import ReactRadioGroup from 'react-radio-button-group';

import Constants from '../../../Phi/Constants';

import DropdownMenu from '../../../Components/DropdownMenu';
import Loader from 'dataphi-react-components/dist/Containers/DataphiLoader/Component/LoaderComponent';

import './HealthHistory.css';



// Constants

const BLOOD_GROUPS = [
    'Select Blood Group',
    'O-',
    'O+',
    'A-',
    'A+',
    'B-',
    'B+',
    'AB-',
    'AB+'
];

const ALLERGIES = [
    'Blood Allergy',
    'Wheat Allergy',
    'Almond Allergy',
    'Others'
];

const SEVERITY = [
    'High',
    'Medium',
    'Low'
];

const ELIGIBILITY_SPORTS = [
    'Fit To Participate',
    'Precautionary Participation',
    'Should Not Participate In Competitive Sport'
];



class HealthHistory extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedDate: this.props.child && this.props.child.profile && Boolean(this.props.child.profile.dob) ? this.props.child.profile.dob : moment().format('YYYY-MM-DD'),
            selectedBloodGroup: BLOOD_GROUPS[0],
            isAllergy: false,
            allergyList: [{
                type: ALLERGIES[0],
                typeText: '',
                whatHappened: '',
                severity: SEVERITY[0],
                medication: ''
            }],
            surgery: false,
            surgeryInfo: '',
            seriousIllness: false,
            seriousIllnessInfo: '',
            others: '',
            eligibilitySports: ELIGIBILITY_SPORTS[0],

            error: ''
            //saving: false
        };
    }


    // Lifecycle Methods

    render() {
        return (
        <div className="hsg-hh-root">
        <Grid>
            
            {/* Save Button Container */}
            <Row className="show-grid">
            <Col xs={12}>
            <div className="hsg-hh-submit-container">
                {this.props.isUpdating ?
                    <div style={{display: 'inline-block', padding: '0 100px'}}><Loader /></div>

                :

                    <div className="hsg-hh-submit-button"
                        onClick={() => this.onSave()}>
                        {/* <span style={{marginRight: 10}}><Glyphicon glyph="save" /></span> */}
                        SAVE
                    </div>}

                {Boolean(this.state.error) && <div className="hsg-hh-submit-error">{this.state.error}</div>}
            </div>
            </Col>
            </Row>


            {/* Health History Form */}
            <Row className="show-grid">
            <Col xs={12}>
            <div className="hsg-hh-form-container soft-card">
            <Row className="show-grid">

                {/* Child's Name */}
                <Col xs={12}>
                    <h3 style={{marginLeft: 20}}>{this.formatName(this.props.child.name)}</h3>
                </Col>

                <Col xs={12}>
                    <hr style={{margin: '0 20px 10px'}} />
                </Col>
            
                {/* Date of Birth input */}
                <Col md={6}>
                <div className="hsg-hh-field-container">
                    <div className="hsg-hh-field-header-text">DATE OF BIRTH</div>

                    {/* <DatePicker
                        dateTime={this.state.selectedDate}
                        format="YYYY-MM-DD"
                        inputFormat="DD/MM/YYYY"
                        viewMode="years"
                        mode="date"
                        disabled={true}
                        // onChange={(date) => this.onChangeDOB(date)} 
                    /> */}

                    <FormGroup controlId={'input-id-dob'}>
                        <FormControl
                            type="text"
                            value={this.state.selectedDate}
                            placeholder=""
                            disabled={true}
                            //onChange={(e) => {this.onChangeAllergyListData('whatHappened', e.target.value, pos)}} 
                        />
                    </FormGroup>
                </div>
                </Col>

            
                {/* Blood Group input */}
                <Col md={6}>
                <div className="hsg-hh-field-container">
                    <div className="hsg-hh-field-header-text">BLOOD GROUP</div>

                    <DropdownMenu
                        value={this.state.selectedBloodGroup || ''}
                        optionList={BLOOD_GROUPS}
                        onChange={(e) => this.onChangeBloodGroup(e)}
                        options={{showMargins: false}} />
                </div>
                </Col>


                <Col xs={12}><div style={{height: 20}} /></Col>

            
                {/* Allergies input */}
                <Col xs={12}>
                <div className="hsg-hh-field-container">
                    <div className="hsg-hh-field-header-text hsg-hh-field-inline-header">ALLERGIES</div>

                    <div className="hsg-hh-radio-group-allergy">
                        <ReactRadioGroup
                            options={['Yes', 'No']}
                            name="Any allergies suffered"
                            value={this.state.isAllergy ? 'Yes' : 'No'}
                            onChange={(value) => this.setState({isAllergy: (value === 'Yes') ? true : false})}
                            inputClassName="hsg-hh-radio-button"
                            labelClassName="hsg-hh-radio-label" />
                    </div>
                </div>
                </Col>


                {/* Allergies Detail input */}
                {this.state.isAllergy &&
                    <Col xs={12}>
                    <div className="hsg-hh-field-container">

                        <Row className="show-grid">

                            <Col md={2}>
                                <div className="hsg-hh-table-header-text">ALLERGY</div>
                            </Col>

                            <Col md={2}>
                                <div className="hsg-hh-table-header-text">TYPE</div>
                            </Col>

                            <Col md={2}>
                                <div className="hsg-hh-table-header-text">WHAT HAPPENED</div>
                            </Col>

                            <Col md={2}>
                                <div className="hsg-hh-table-header-text">SEVERITY</div>
                            </Col>

                            <Col md={4}>
                                <div className="hsg-hh-table-header-text">MEDICATION TAKEN</div>
                            </Col>

                        </Row>

                        <hr style={{margin: '5px 0 15px'}} />


                        {this.renderAllergyFormList()}


                        <span className="hsg-hh-text-link"
                            onClick={(() => this.onAddNewAllergyRow())}>
                            + ADD NEW ROW
                        </span>

                    </div>
                    </Col>}


                <Col xs={12}><div style={{height: 20}} /></Col>

                
                {/* History of procedures and illness section */}
                <Col xs={12}>
                <div className="hsg-hh-field-container">
                    <div className="hsg-hh-field-header-text">HISTORY OF PROCEDURES AND ILLNESS</div>

                    <div style={{height: 20}} />

                    <Row className="show-grid">

                        <Col lg={2} md={3} sm={4} xs={12}>
                            <div className="hsg-hh-field-label-text">Surgery</div>
                        </Col>


                        <Col lg={10} md={9} sm={8} xs={12}>
                            <CheckInput
                                showInput={this.state.surgery}
                                inputText={this.state.surgeryInfo}
                                onToggle={(status) => this.setState({surgery: status})}
                                onChangeInput={(value) => this.setState({surgeryInfo: value})} />
                        </Col>

                    </Row>

                    <div style={{height: 20}} />

                    <Row className="show-grid">

                        <Col lg={2} md={3} sm={4} xs={12}>
                            <div className="hsg-hh-field-label-text">Serious Illness</div>
                        </Col>


                        <Col lg={10} md={9} sm={8} xs={12}>
                            <CheckInput
                                showInput={this.state.seriousIllness}
                                inputText={this.state.seriousIllnessInfo}
                                onToggle={(status) => this.setState({seriousIllness: status})}
                                onChangeInput={(value) => this.setState({seriousIllnessInfo: value})} />
                        </Col>

                    </Row>

                    <div style={{height: 20}} />

                    <Row className="show-grid">

                        <Col lg={2} md={3} sm={4} xs={12}>
                            <div className="hsg-hh-field-label-text">Others</div>
                        </Col>


                        <Col lg={10} md={9} sm={8} xs={12}>
                            <CheckInput
                                showInput={true}
                                hideRemove={true}
                                inputText={this.state.others}
                                onToggle={(status) => {}}
                                onChangeInput={(value) => this.setState({others: value})} />
                        </Col>

                    </Row>
                    
                </div>
                </Col>


                <Col xs={12}><div style={{height: 20}} /></Col>


                {/* Eligibility for sports section */}
                <Col xs={12}>
                <div className="hsg-hh-field-container">
                    <div className="hsg-hh-field-header-text">ELIGIBILITY FOR SPORTS</div>
                        <ReactRadioGroup
                            options={ELIGIBILITY_SPORTS}
                            name=""
                            value={this.state.eligibilitySports}
                            onChange={(value) => this.setState({eligibilitySports: value})}
                            inputClassName="hsg-hh-radio-button"
                            labelClassName="hsg-hh-radio-label"
                            itemClassName=".hsg-hh-item-group col-xs-12 col-md-3" 
                            groupClassName="hsg-hh-radio-group-es"
                        />
                </div>
                </Col>

            </Row>
            </div>
            </Col>
            </Row>

        </Grid>
        </div>);
    }


    componentDidMount() {
        this.setState({ windowWidth: window.innerWidth });

        if (this.props.child && this.props.child.healthHistory) {
            this.setState(this.parseData(this.props.child.healthHistory));
            this.setState({ selectedDate: this.props.child.dob });
        }
    }


    componentWillReceiveProps(newProps) {
        // if(newProps.child !== this.props.child) {

        //     if(newProps.child && Boolean(newProps.child.profile)){
        //         this.setState({selectedDate: newProps.child.profile.dob})
        //     }

        //     if(newProps.child && newProps.child.custom && Boolean(newProps.child.custom.healthHistory)) {
        //         this.setState(this.parseData(newProps.child.custom.healthHistory));
        //     }
        //     else {
        //         const defaultState = {
        //             selectedDate: newProps.child && newProps.child.profile && newProps.child.profile.dob ? newProps.child.profile.dob : moment().format('YYYY-MM-DD'),
        //             selectedBloodGroup: BLOOD_GROUPS[0],
        //             isAllergy: false,
        //             allergyList: [{
        //                 type: ALLERGIES[0],
        //                 typeText: '',
        //                 whatHappened: '',
        //                 severity: SEVERITY[0],
        //                 medication: ''
        //             }],
        //             surgery: false,
        //             surgeryInfo: '',
        //             seriousIllness: false,
        //             seriousIllnessInfo: '',
        //             others: '',
        //             eligibilitySports: ELIGIBILITY_SPORTS[0],

        //             error: ''
        //         };

        //         this.setState(defaultState);
        //     }
        // }

        if (newProps.child.userId !== this.props.child.userId) {
            this.setState({ selectedDate: newProps.child.dob });

            if (newProps.child && newProps.child.healthHistory) {
                this.setState(this.parseData(newProps.child.healthHistory));
            } else {
                const defaultState = {
                    selectedBloodGroup: BLOOD_GROUPS[0],

                    historyList: [],
                    medicationList: [],

                    eligibilitySports: ELIGIBILITY_SPORTS[0],

                    error: ""
                };

                this.setState(defaultState);
            }
        }

        if (this.props.isUpdating && !!!newProps.isUpdating) {
            this.setState(this.parseData(newProps.child.healthHistory));
        }


        // if(!newProps.isUpdating && this.props.isUpdating) {
        //     if(newProps.updateStatus) {
        //         this.props.fetchChildList(newProps.user.userId);
        //     }

        //     else {
        //         this.setState({error: 'Unable to Save'});
        //     }
        // }
    }


    // Rendering Methods

    renderAllergyFormList() {
        return this.state.allergyList.map((item, pos) => (
            <Row className="show-grid"
                key={pos}
                style={{marginTop: 10}}>

                <Col md={2} style={{paddingRight: 0}}>
                    <DropdownMenu
                        value={item.type}
                        optionList={ALLERGIES}
                        onChange={(e) => {this.onChangeAllergyListData('type', e.target.value, pos)}}
                        options={{showMargins: false}} />
                </Col>

                <Col md={2} style={{paddingRight: 0}}>
                    <FormGroup controlId={'input-allergyType' + pos}>
                        <FormControl
                            type="text"
                            value={item.typeText}
                            placeholder="If others, please specify"
                            onChange={(e) => {this.onChangeAllergyListData('typeText', e.target.value, pos)}} />
                    </FormGroup>
                </Col>

                <Col md={2} style={{paddingRight: 0}}>
                    <FormGroup controlId={'input-whatHappened' + pos}>
                        <FormControl
                            type="text"
                            value={item.whatHappened}
                            placeholder=""
                            onChange={(e) => {this.onChangeAllergyListData('whatHappened', e.target.value, pos)}} />
                    </FormGroup>
                </Col>
            
                <Col md={2} style={{paddingRight: 0}}>
                    <DropdownMenu
                        value={item.severity || ''}
                        optionList={SEVERITY}
                        onChange={(e) => {this.onChangeAllergyListData('severity', e.target.value, pos)}}
                        options={{showMargins: false}} />
                </Col>

                <Col md={4}>
                    <FormGroup controlId={'input-medication' + pos}>
                        <FormControl
                            type="text"
                            value={item.medication}
                            placeholder="Medication taken at the time of allergic reaction"
                            onChange={(e) => {this.onChangeAllergyListData('medication', e.target.value, pos)}} />
                    </FormGroup>
                </Col>


                {pos > 0 &&
                <Col xs={12}>
                <div className="hsg-hh-text-link text-end"
                    style={{marginTop: -10}}
                    onClick={() => this.onRemoveAllergyRow(pos)}>
                    REMOVE
                </div>
                </Col>}

            </Row>));
    }


    // Event Listeners

    onChangeDOB(date) {
        this.setState({selectedDate: date});
    }


    onChangeBloodGroup(e) {
        this.setState({selectedBloodGroup: e.target.value});
    }


    onChangeAllergyListData(key, value, pos) {
        const list = this.state.allergyList;
        const item = list[pos];

        item[key] = value;
        
        list[pos] = item;

        this.setState({allergyList: list.map((item) => item)});
    }


    onAddNewAllergyRow() {
        const list = this.state.allergyList;

        list.push({
            type: ALLERGIES[0],
            typeText: '',
            whatHappened: '',
            severity: SEVERITY[0],
            medication: ''
        });

        this.setState({allergyList: list.map((item) => item)});
    }


    onRemoveAllergyRow(pos) {
        const list = this.state.allergyList;

        list.splice(pos, 1);

        this.setState({allergyList: list.map((item) => item)});
    }


    onSave() {
        this.setState({error: ''});
        this.props.saveHealthHistory(this.generatePayload());
    }


    // Other Methods

    generatePayload() {
        const payload = {
            hsgId: this.props.child.uuId,
            currentUserId: this.props.user.userId,
            description: 'Updating student Health History from Parent Dashboard'
        };

        const custom = {
            healthHistory: {
                //dob: this.state.selectedDate,
                bloodGroup: this.state.selectedBloodGroup,
                isAllergy: this.state.isAllergy,
                allergyList: this.state.isAllergy ? this.state.allergyList : [],
                surgery: this.state.surgery,
                surgeryInfo: this.state.surgeryInfo,
                seriousIllness: this.state.seriousIllness,
                seriousIllnessInfo: this.state.seriousIllnessInfo,
                others: this.state.others,
                eligibilitySports: this.state.eligibilitySports
            }
        };

        payload.newCustom = JSON.stringify(custom);

        return payload;
    }


    parseData(data, profile) {
        const state = {};

        state.selectedBloodGroup = data.bloodGroup;
        state.isAllergy = data.isAllergy;
        state.allergyList = data.isAllergy ? cloneArray(data.allergyList) : [{
            type: ALLERGIES[0],
            typeText: '',
            whatHappened: '',
            severity: SEVERITY[0],
            medication: ''
        }];
        state.surgery = data.surgery;
        state.surgeryInfo = data.surgery ? data.surgeryInfo : '';
        state.seriousIllness = data.seriousIllness;
        state.seriousIllnessInfo = data.seriousIllness ? data.seriousIllnessInfo : '';
        state.others = data.others;
        state.eligibilitySports = data.eligibilitySports;

        return state;
    }


    formatName(name) {
        if(typeof name !== 'string') return '';

        name = name.toLowerCase().trim();

        let result = '';

        for(let i=0 ; i < name.length ; i++) {
            const char = name.charAt(i);

            if(i === 0) {
                result = char.toUpperCase();
            }

            else if(name.charAt(i - 1) === ' ' || name.charAt(i - 1) === '.') {
                result += char.toUpperCase();
            }

            else {
                result += char;
            }
        }

        return result;
    }

}



// Local Components

class CheckInput extends Component {

    render() {
        const props = this.props;

        return (
        <div className="hsg-checkinput-root">
        
            {/* Input Container */}
            {props.showInput &&
            <div className="hsg-checkinput-input-container">
            <Row className="show-grid">

                <Col lg={11} md={10} sm={8} xs={props.hideRemove ? 12 : 9}>
                    <FormGroup>
                        <FormControl
                            type="text"
                            value={props.inputText}
                            placeholder={props.placeholder || ''}
                            onChange={(e) => props.onChangeInput(e.target.value)} />
                    </FormGroup>
                </Col>


                {!Boolean(props.hideRemove) &&
                <Col lg={1} md={2} sm={4} xs={3}>
                    <div className="hsg-checkinput-remove-container"
                        onClick={() => props.onToggle(false)}>
                        <span className="hsg-checkinput-remove-button">REMOVE</span>
                    </div>
                </Col>}

            </Row>
            </div>}


            {!props.showInput &&
            <div className="hsg-checkinput-radio-container">
                
                <div className="hsg-checkinput-radio-wrapper">
                    <ReactRadioGroup
                        options={['None']}
                        name=""
                        value={'None'}
                        onChange={(value) => {}}
                        inputClassName="hsg-hh-radio-button"
                        labelClassName="hsg-hh-radio-label" />
                </div>


                <span className="hsg-checkinput-add-button"
                    onClick={() => props.onToggle(true)}>+ ADD</span>

            </div>}
        
        </div>);
    }

}


CheckInput.propTypes = {
    showInput: PropTypes.bool.isRequired,
    inputText: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    hideRemove: PropTypes.bool,
    onToggle: PropTypes.func.isRequired,
    onChangeInput: PropTypes.func.isRequired
};



export default HealthHistory





function cloneArray(arr) {
    const result = [];

    if(typeof arr === 'array' || arr.length > 0) {
        arr.forEach((item) => {
            result.push(Object.assign({}, item));
        });
    }

    return result;
}